import { InputAdornment, TextField } from "@material-ui/core";
import { SearchOutlined } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

export function SearchInput({ disabled, handleSearch }) {
  const { t } = useTranslation("global")

  return (
    <TextField
      className="sig_SignsDB_Search sig_Home_ChangeChildIconOnDarkMode"
      onChange={handleSearch}
      variant="outlined"
      label= {t("search")}
      disabled={disabled}
      required
      fullWidth
      autoFocus
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchOutlined />
          </InputAdornment>
        ),
      }}
    />
  );
}
